import haversine from 'haversine';

export const googleIsLoaded = () =>
  new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (typeof google !== 'undefined') {
        clearInterval(interval);
        resolve();
      }
    }, 100);

    setTimeout(() => {
      clearInterval(interval);
      reject();
    }, 10000);
  });

const distance = ({ lat: lat1, lng: lng1 }, { lat: lat2, lng: lng2 }) => {
  const start = {
    latitude: lat1,
    longitude: lng1,
  };
  const end = {
    latitude: typeof lat2 === 'function' ? lat2() : lat2,
    longitude: typeof lng2 === 'function' ? lng2() : lng2,
  };
  return haversine(start, end);
};

export const addDistance = (dealer, pinnedAddress) => ({
  ...dealer,
  distance:
    dealer.location.lat && dealer.location.lng
      ? distance(dealer.location, pinnedAddress.geometry.location)
      : null,
});
